// クエリを扱うサービスです。
// TODO ちょっと汚くなってきているのでリファクタリングする
//      実際にGiggle APIにアクセスする関数とURLを構築する関数が混じってしまっている
//      ので原則APIにアクセスする（axiosを使う）関数にしたい。URL構築だけしても
//      どうせ利用側でrepository.giggleを参照しないとってことになってしまうので。。。

import Vue from 'vue'
import repository from '@/repositories/Repository'
import token from '@/services/token'

// 各コンポーネントからアクセスするときの名前登録（テンプレ）
Vue.mixin({
  beforeCreate() {
    const options = this.$options
    if (options.longQuery) this.$longQuery = options.longQuery
    else if (options.parent && options.parent.$longQuery)
      this.$longQuery = options.parent.$longQuery
  },
})

const storage = sessionStorage
const lastingStorage = localStorage

async function getSavedUserId() {
  const t = await token.retrieveToken()
  return t.userId
}

export default {
  /**
   * リソース（メニュー）毎の分析条件を保存する
   */
  async saveMenuQueryFilter(resourceName, queryFilter) {
    await repository.giggle
      .post(`/api/query-filter/${resourceName}`, queryFilter)
      .then(r => r.data)

    return Promise.resolve(undefined)
  },
  /**
   * リソース（メニュー）毎の分析条件を取得する
   */
  async fetchMenuQueryFilter(menuCode) {
    let queryFilter = await repository.giggle
      .get(`/api/query-filter/${menuCode}`)
      .then(r => r.data)

    if (!queryFilter) {
      // サーバーサイドになければlocalstorageから
      const userId = await getSavedUserId()

      queryFilter = lastingStorage.getItem(
        `giggle.queryfilter.${menuCode}.${userId}.latest`,
      )
      if (queryFilter) {
        queryFilter = JSON.parse(queryFilter)
      }
    }

    // 顧客グループコードは削除されている可能性があるので復元しない
    if (queryFilter) {
      if (queryFilter.customer) {
        queryFilter.customer.customerGroupId = undefined
      }

      return Promise.resolve(queryFilter)
    } else {
      return Promise.resolve(undefined)
    }
  },
  /**
   * リソース（メニュー）毎の分析条件を削除する
   */
  async deleteMenuQueryFilter(menuCode) {
    await repository.giggle
      .delete(`/api/query-filter/${menuCode}`)
      .then(r => r.data)
  },
  /**
   * 分析条件を保存する
   */
  async saveQueryFilter(queryId, queryFilter) {
    const response = await repository.giggle.post(
      `/api/query-filter/history/${queryId}`,
      queryFilter,
    )
    return response.data
  },
  /**
   * 指定したQueryIdから分析条件と制限モード状態を取得する。
   * @param {string} queryId - 分析ID
   * @returns {object}: 分析実行時のフィルター条件(GCSバケットから取得)
   */
  async fetchQueryFilter(queryId) {
    const queryFilter = await repository.giggle
      .get(`/api/query-filter/history/${queryId}`)
      .then(r => r.data)
    // 分析条件だけ返す
    return queryFilter
  },
  /**
   * 画面遷移ができないルートを追加します
   *
   * 分析実行時の各種分析IDから遷移できないルート操作を判定します。
   *
   * queryIdsに入っているIDは以下の通り
   *
   * * ref
   *
   * 画面遷移で引き継ぐIDとして指定された分析ID。このIDに貯められているルートに
   * 今回のルートを追加します。
   *
   * * current
   *
   * 直前に実行された分析の分析ID。このIDにブロックルートを紐付けます。
   * たとえ今までのブロックルートがあったとしても、自画面の分析ボタンを押したら
   * 履歴はリセットされます。
   *
   * @param {Object} queryIds
   * @param {String} resourceName
   * @param {String} option
   */
  pushBlockRoute({ ref, current }, resourceName, option) {
    let history = ''
    if (ref) {
      history = storage.getItem(`giggle.blockroute.${ref}`)
    }

    const route = resourceName + (option ? `/${option}` : '')

    storage.setItem(`giggle.blockroute.${current}`, [history, route].join(' '))

    return Promise.resolve()
  },
  fetchBlockRoute(queryId) {
    const routes = storage.getItem(`giggle.blockroute.${queryId}`)
    return routes ? Promise.resolve(routes.split(' ')) : Promise.resolve([])
  },
  /**
   * クエリを実行する
   *
   * 送信データにフォーマット不正等がなければ受付完了として即時レスポンスがあります。
   *
   * TODO フォーマット不正でエラーとなった場合の対処。
   */
  async executeQuery(resourceName, postData) {
    const response = await repository.giggle.post(
      `/api/${resourceName}`,
      postData,
    )
    return response.data
  },
  /**
   * クエリの詳細を取得する
   *
   * クエリ結果（データ）の参照ではないので注意
   */
  async fetchQueryInfo(_, queryId) {
    const response = await repository.giggle.get(`/api/query/${queryId}`)
    return response.data
  },
  /**
   * クエリ結果を取得するURL構築する
   *
   * * resourceName = pudding-s
   * * queryId = 6751b472c25
   * * option（Optional） = summary
   *
   * => 「/api/pudding-s/6751b472c25/fetch/summary」
   *
   * TODO 以前はトークンを取得したりするのでasyncにしていたと思うのですが、
   *      もう不要。
   */
  async getQueryResultFetchUrl(resourceName, queryId, option) {
    return `${
      process.env.VUE_APP_QUERY_API_URL_BASE
    }/api/${resourceName}/${queryId}/fetch${option ? '/' + option : ''}`
  },
  /**
   * ColModelを取得するURLを構築する
   *
   * **結果の表が複数あるなどでQueryInfoにグリッド定義が取得できない画面用
   * に作成した関数です。通常の画面では使用する必要はありません。**
   */
  getColModelFetchUrl(resourceName, queryId, option) {
    return `${
      process.env.VUE_APP_QUERY_API_URL_BASE
    }/api/${resourceName}/${queryId}/columns${option ? '/' + option : ''}`
  },
  /**
   * エクセル出力URL構築する
   */
  getExcelUrl(resourceName, queryId, extraProps) {
    const params = new URLSearchParams()
    for (const [key, value] of Object.entries(extraProps)) {
      if (Array.isArray(value)) {
        value.forEach(v => params.append(key, v))
      } else {
        params.append(key, value)
      }
    }

    return repository.giggle
      .get(`/api/${resourceName}/${queryId}/excel?${params.toString()}`)
      .then(r => r.data)
  },
  // TODO Heron導入時に間に合わせで作ったやつ。
  queryGiggleResource(callback) {
    const base = '/api/'
    const url = callback(base)
    return repository.giggle.get(url).then(r => r.data)
  },
  /**
   * クエリ結果を取得して、カテゴリコードをList型で返す
   */
  async fetchAllCategoryListForDrillDown(resourceName, queryId, params) {
    let url = await this.getQueryResultFetchUrl(resourceName, queryId)
    if (url.indexOf('?') === -1) {
      url += '?'
    }
    if (params) {
      for (const k of Object.keys(params)) {
        url += `&${k}=${params[k]}`
      }
    }
    const response = await repository.giggle.get(url).then(r => r.data)
    return response.rows.map(r => r.code)
  },
}
